var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDegrees(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2634_93722",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2634_93722)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 20.725C11.8333 20.725 11.6707 20.7044 11.512 20.663C11.354 20.621 11.2 20.5584 11.05 20.475L6.05001 17.775C5.71668 17.5917 5.45835 17.346 5.27501 17.038C5.09168 16.7294 5.00001 16.3834 5.00001 16V11.2L2.60001 9.87502C2.41668 9.77502 2.28335 9.65002 2.20001 9.50002C2.11668 9.35002 2.07501 9.18336 2.07501 9.00002C2.07501 8.81669 2.11668 8.65002 2.20001 8.50002C2.28335 8.35002 2.41668 8.22502 2.60001 8.12502L11.05 3.52502C11.2 3.44169 11.354 3.37902 11.512 3.33702C11.6707 3.29569 11.8333 3.27502 12 3.27502C12.1667 3.27502 12.3293 3.29569 12.488 3.33702C12.646 3.37902 12.8 3.44169 12.95 3.52502L22.475 8.72502C22.6417 8.80836 22.771 8.92902 22.863 9.08702C22.9543 9.24569 23 9.41669 23 9.60002V16C23 16.2834 22.904 16.5207 22.712 16.712C22.5207 16.904 22.2833 17 22 17C21.7167 17 21.4793 16.904 21.288 16.712C21.096 16.5207 21 16.2834 21 16V10.1L19 11.2V16C19 16.3834 18.9083 16.7294 18.725 17.038C18.5417 17.346 18.2833 17.5917 17.95 17.775L12.95 20.475C12.8 20.5584 12.646 20.621 12.488 20.663C12.3293 20.7044 12.1667 20.725 12 20.725ZM12 12.7L18.85 9.00002L12 5.30002L5.15001 9.00002L12 12.7ZM12 18.725L17 16.025V12.25L12.975 14.475C12.825 14.5584 12.6667 14.6207 12.5 14.662C12.3333 14.704 12.1667 14.725 12 14.725C11.8333 14.725 11.6667 14.704 11.5 14.662C11.3333 14.6207 11.175 14.5584 11.025 14.475L7.00001 12.25V16.025L12 18.725Z",
    fill: "#1F242F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDegrees);
export default __webpack_public_path__ + "static/media/degrees.acbbd019e3e6b3198390966503c2e685.svg";
export { ForwardRef as ReactComponent };